module.exports = __webpack_public_path__ + "img/rehau4.886e8fe7.jpg";